import { connect } from 'react-redux';
import ProjectOverview from './ProjectOverview';
import { getProjectDoc, updateProjectDoc } from '../../../actions';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { docs },
    projects: { docById },
  } = state;

  let { data } = ownProps;

  return {
    isLoading: {
      doc: request.GET_PROJECT_DOCUMENTATION_REQUEST || false,
    },
    doc: data && docById[data.id] && docs[docById[data.id]] ? docs[docById[data.id]].text : null,
  };
};

export default connect(mapStateToProps, {
  getProjectDoc,
  updateProjectDoc,
})(ProjectOverview);
